define(
'shared/initializer/form/adapters/mixins/ProtocolGuarantee',[
    'shared/lib/RSVP',
    'shared/util/Domain'
], 
function (RSVP, Domain) {
    'use strict';

    function Ctor() { }

    Ctor.prototype.doPageLoad = function() {
        var $form = this.$form;

        if(window.location.protocol === 'https:') {
            return;
        }

        if( $form == null || $form.length <= 0 ){
            return;
        }

        var currentDomain = new Domain(window.location.hostname);
        var action = $form.attr('action');

        if (action && action.indexOf('https://') === 0) {
            return RSVP.resolve();
        }
        else{
            return currentDomain.get.secure().then(function(secureDomain){
                $form.attr('action', 'https://' + secureDomain + action);
                return RSVP.resolve();
            });
        }
    };

    

    return Ctor;
});
